import React, { useState, useEffect } from "react";
import "./Permission.css";

const Permission = () => {
  const [audioAllowed, setAudioAllowed] = useState(false);
  const [videoAllowed, setVideoAllowed] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    checkPermissions();
  }, []);

  const checkPermissions = async () => {
    try {
      const audioStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });
      audioStream.getTracks().forEach((track) => track.stop());
      setAudioAllowed(true);
    } catch (error) {
      handleError(error, "microphone");
      return;
    }

    try {
      const videoStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      videoStream.getTracks().forEach((track) => track.stop());
      setVideoAllowed(true);
    } catch (error) {
      handleError(error, "camera");
    }
  };

  const handleError = (error, deviceType) => {
    console.log(`${deviceType} error:`, error.name);

    switch (error.name) {
      case "NotAllowedError":
        setErrorMessage({
          title: `${
            deviceType === "microphone" ? "Microphone" : "Camera"
          } Access Denied`,
          description: `To enable ${deviceType} access, click the camera icon in your browser's address bar and choose 'Allow'.`,
        });
        break;
      case "NotFoundError":
        setErrorMessage({
          title: `${
            deviceType === "microphone" ? "Microphone" : "Camera"
          } Not Found`,
          description: `Could not find a ${deviceType}. Please ensure your device is properly connected.`,
        });
        break;
      case "NotReadableError":
        setErrorMessage({
          title: `${
            deviceType === "microphone" ? "Microphone" : "Camera"
          } In Use`,
          description: `Your ${deviceType} might be in use by another application. Please close other applications and try again.`,
        });
        break;
      default:
        setErrorMessage({
          title: "Permission Error",
          description: `An error occurred while accessing your ${deviceType}. Please try again.`,
        });
    }
  };

  const renderContent = () => {
    if (audioAllowed && videoAllowed) {
      return (
        <div className="success-message">
          <h5>Access Granted!</h5>
          <p>You can now use the microphone and camera.</p>
        </div>
      );
    }

    if (errorMessage) {
      return (
        <div className="error-message">
          <h5>{errorMessage.title}</h5>
          <p>{errorMessage.description}</p>
          <button className="retry-button" onClick={checkPermissions}>
            Try Again
          </button>
        </div>
      );
    }

    return (
      <div className="loading-message">
        <h5>Requesting Permissions...</h5>
        <p>Please allow access to your camera and microphone when prompted.</p>
      </div>
    );
  };

  return <div className="permission-container">{renderContent()}</div>;
};

export default Permission;
